module.exports = __webpack_public_path__ + "img/right-to-line.fd166b06.svg";